import { getImageBase64Src } from "../utils/utility";
import { Alert } from "../elements/Alert";
import { Audit } from "./EntityInformation.types";

const byLabel = (a: { Label?: string }, b: { Label?: string }) => (a.Label ?? "").localeCompare(b.Label ?? "");

function AttributesTable({ audit }: { audit: Audit }) {
  if (!audit.Attributes?.length) {
    return null;
  }

  return (
    <table className="table">
      <thead>
        <tr>
          <th scope="col" className="col-name">
            Column
          </th>
          <th scope="col">Value</th>
        </tr>
      </thead>
      <tbody>
        {[...audit.Attributes]
          .sort((a, b) => a.Key.localeCompare(b.Key))
          .map((attribute) => (
            <tr key={attribute.Key}>
              <td>{attribute.Key}</td>
              <td>{attribute.Value}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}

function imageOf(audit: Audit) {
  const mimeType = audit.Attributes.find((a) => a.Key === "mimetype");
  const body = audit.Attributes.find((a) => a.Key === "documentbody");

  return audit.EntityName === "annotation" && mimeType && body ? getImageBase64Src(mimeType.Value, body.Value) : null;
}

/** One audit: what changed, then the records related to and linked from it. */
export function EntityAudit({ audit }: { audit: Audit }) {
  return (
    <div>
      <AttributesTable audit={audit} />
      {[...audit.Related].sort(byLabel).map((related, index) => {
        const image = imageOf(related);

        return (
          <div key={index} className="my-3">
            <h4>{related.Label}</h4>
            {image === null ? (
              <AttributesTable audit={related} />
            ) : related.Type === 2 ? (
              <Alert text="Image deleted" />
            ) : (
              <div>
                <img src={image} alt="" />
              </div>
            )}
          </div>
        );
      })}
      {[...audit.Linked].sort(byLabel).map((linked, index) => (
        <div key={index} className="my-3">
          <h4>{linked.Label}</h4>
          {linked.EntityLookups.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th scope="col" className="col-name">
                    Name
                  </th>
                  <th scope="col">Id</th>
                </tr>
              </thead>
              <tbody>
                {linked.EntityLookups.map((lookup, lookupIndex) => (
                  <tr key={lookupIndex}>
                    <td>{lookup.Name}</td>
                    <td>{lookup.Id}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No linked records</p>
          )}
        </div>
      ))}
    </div>
  );
}

export default EntityAudit;
